<template>
  <v-container>
    <v-row>
      <v-col
        v-for="(crewmember, idx) in crew" :key="idx"
        class="pa-0 mb-2"
        cols=12
      >
        <v-card
          elevation="0"
          outlined
          tile
          >
          <v-card-title>
            {{$t('crewmember')}} {{ idx + 1 }}
            <v-spacer></v-spacer>
              <v-btn
                icon
                x-small
                @click="remove(idx)"
                >
                <v-icon
                  class="mdi mdi-close"
                  >
                </v-icon>
              </v-btn>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col
                cols=12
                sm=4
              >
                <v-text-field
                  :label="$t('given_names_&_surnames')"
                  v-model="crew[idx]['name']"
                />
              </v-col>

              <v-col
                cols=6
                sm=4
              >
                <date-picker :label="$t('date_of_birth')" :picker="crew[idx]"></date-picker>
              </v-col>

              <v-col
                cols=6
                sm=4
              >
                <v-select
                  :items="nationalities"
                  :label="$t('nationality')"
                  :item-text="item => $t(item.text)"
                  item-value="value"
                  v-model="crew[idx]['nationality']"
                  clearable
                ></v-select>
              </v-col>

              <v-col
                cols=12
                sm=4
              >
                <v-select v-if="vesselType !== 'aeroplane'"
                  :items="ranks"
                  :label="$t('rank')"
                  :item-text="item => $t(item.text)"
                  item-value="value"
                  v-model="crew[idx]['rank']"
                  clearable
                ></v-select>

                <v-select
                  v-if="vesselType === 'aeroplane'"
                  :items="flight_ranks"
                  :label="$t('rank')"
                  :item-text="item => $t(item.text)"
                  item-value="value"
                  v-model="crew[idx]['rank']"
                  clearable
                ></v-select>
              </v-col>

              <v-col
                cols=12
                sm=4
              >
                <v-select
                  :items="documents"
                  :label="$t('document_type')"
                  :item-text="item => $t(item.text)"
                  item-value="value"
                  v-model="crew[idx]['document_type']"
                  clearable
                ></v-select>
              </v-col>

              <v-col
                cols=12
                sm=4
              >
                <v-text-field
                  :label="$t('document_number')"
                  v-model="crew[idx]['document_number']"
                />
              </v-col>

              <v-col
                cols=12
              >
                <v-textarea
                  v-model="crew[idx]['details']"
                  outlined
                  rows=2
                  :label="$t('details')"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols=6
        class="ml-0 pl-0"
      >
        <v-btn
          class="minor-add-btn"
          small
          :block="$vuetify.breakpoint.smAndDown"
          plain
          raised
          tile
          elevation=1
          color="primary"
          @click="addMore"
          >
          {{$t('add_crew_member')}}
        </v-btn>
      </v-col>

      <v-col
        class="pr-0"
        cols=6
        md=3
        offset-md=3
      >
        <vue-dropzone
          id='crew-import'
          ref="importCrew"
          @vdropzone-file-added="importCrewList"
          :options="importDropzoneOptions"
          :useCustomSlot="true"
        >
          <div class="dz-message px-3 py-1" data-dz-message>
            <v-icon
              light
              color="grey darken-">mdi-file</v-icon>
            <span>{{ $t('import_crew') }}</span>
          </div>
        </vue-dropzone>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { maocData } from '../../services/MaocData'
import DatePicker from '../ui/DatePicker.vue'
import { ExportUtils } from '../../services/DataExport'
import { ExcelExport, ExcelImport } from '../../services/ExcelUtils'
import vue2Dropzone from 'vue2-dropzone'

export default {
  name: 'CrewData',
  components: {
    DatePicker,
    vueDropzone: vue2Dropzone
  },
  props: ['vesselType'],
  data: vm => ({
    nationalities: maocData.dynamicLocalizedSelect('countries'),
    ranks: maocData.dynamicLocalizedSelect('ranks'),
    flight_ranks: maocData.dynamicLocalizedSelect('flight_ranks'),
    documents: maocData.dynamicLocalizedSelect('documents'),
    menu: [],
    date: null,
    crew: [DatePicker.newPickerObject()],
    importDropzoneOptions: {
      url: '#',
      autoProcessQueue: false,
      addRemoveLinks: true,
      maxFilesize: 1,
      acceptedFiles: '.xlsx',
      dictDefaultMessage: '<i class="fa fa-file"></i>' + 'Import Crew List'
    }
  }),
  methods: {
    addMore () {
      this.crew.push(DatePicker.newPickerObject())
    },
    remove (idx) {
      this.crew.splice(idx, 1)
    },
    getData: function () {
      var data = []
      var vm = this
      this.crew.forEach(function (member) {
        var newMember = ExportUtils.copyObject(member, ['menu', 'rawdate'])
        if (!ExportUtils.isObjectEmpty(newMember)) {
          if (newMember.nationality) {
            newMember.nationality_en = vm.$t('countries.' + newMember.nationality, 'en')
          }

          if (newMember.rank) {
            newMember.rank_en = vm.$t('all_ranks.' + newMember.rank, 'en')
          }

          if (newMember.document_type) {
            newMember.document_type_en = vm.$t('documents.' + newMember.document_type, 'en')
          }

          data.push(newMember)
        }
      })

      return data
    },
    setData: function (data) {
      this.crew = data
    },
    exportCrewManifest: function () {
      ExcelExport.exportExcelCrewManifest(this.getData())
    },
    importCrewList: function (file) {
      const vm = this
      this.$refs.importCrew.removeFile(file)
      ExcelImport.readExcelFile(file, function (crewData) {
        vm.crew = []
        crewData.forEach(function (item) {
          if (!ExportUtils.isObjectEmpty(item)) {
            vm.crew.push(
              ExportUtils.arrayToCrewmember(item)
            )
          }
        })
      })
    }
  }
}
</script>
